export default "__VITE_ASSET__CK64N_gB__"